import styled from "styled-components";

export const Style = styled.div`
  .knockContainer {
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: visible;
    background: #000;
    min-height: 100vh;
    height: 100vh;
  }

  .line {
    padding: 3px 0;
    margin: 10px 20px;
    background: #262626;
    border-radius: 50px;
  }

  .row {
    display: flex;
    align-items: center;
  }

  h3 {
    font-size: 24px;
    line-height: 28px;
    color: #ffffff;
    font-weight: 200;
    margin: 0 0;
  }

  .deliveryTitle {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 20px;

    h2 {
      font-size: 28px;
      line-height: 42px;
      font-weight: 600;
    }
    .row {
      gap: 8px;
    }
    img {
      max-height: 36px;
    }
    .commentBox {
      padding: 6px 10px;
      background: #ffffff80;

      img {
        width: 17px;
        margin-right: 4px;
      }
      h4 {
        font-size: 16px;
        font-weight: 500;
        color: #262626;
        white-space: nowrap;
      }
    }
  }

  .normalStoreWrap {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    align-content: center;
    gap: 10px;
  }

  .normalStoreWrap.sector {
    gap: 20px;
  }
  .sectorItem {
    width: calc((100% - 80px) / 5);
    aspect-ratio: 6/5;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 10px;
    padding: 6px 0;
    gap: 4px;
    img {
      width: 60px;
      height: 60px;
    }
    h3 {
      font-size: 18px;
      line-height: 20px;
      font-weight: 400;
      white-space: normal;
      text-align: center;
    }
  }
  .sectorItem.active {
    background: #393939;
  }

  .storeItem {
    width: calc((100% - 20px) / 3);
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    .closeItem {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .closedImg {
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 5px 5px 0 0;
    background: rgba(0, 0, 0, 0.5);
    color: #ffffff;
    font-size: 28px;
    line-height: 46px;
    z-index: 2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: pre-wrap;
    text-align: center;
    padding-bottom: 40px;

    img {
      width: 150px;
      height: 150px;
    }
  }

  .titleImg {
    width: 100%;
    aspect-ratio: 5/4;
    object-fit: cover;
    border-radius: 10px;
  }

  .itemContent {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 14px;
    background: #000;

    p {
      color: #ffffff;
      font-size: 20px;
      line-height: 30px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .centerWrap {
    width: 100%;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    .line {
      margin: 10px 0;
    }
  }

  .directlyStoreWrap {
    padding: 20px;

    .row {
      gap: 20px;
      .typeButton {
        font-size: 28px;
        line-height: 42px;
        font-weight: 500;
        color: #a7a7a7;
        padding: 4px 10px;
        z-index: 1;
      }
      .typeButton.active {
        color: #fff;
        font-weight: 600;
      }
    }

    .scrollWrap {
      display: flex;
      overflow-x: auto;
      overflow-y: hidden;
      margin-right: -20px;
      padding-top: 10px;
      gap: 10px;
    }

    .storeItem {
      min-width: 19vw;
      max-width: 19vw;

      .titleImg {
        aspect-ratio: 1/1;
      }
      img {
        object-fit: cover;
        border-radius: 5px;
      }
      .closedImg {
        font-size: 20px;
        line-height: 34px;
      }
      .itemContent {
        width: 100%;
        text-align: center;
        padding: 2px 10px;
      }
    }
  }

  .timeBadge {
    padding: 6px 10px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
    border-radius: 50px;
    white-space: nowrap;
    img {
      height: 20px;
    }
  }
  .timeBadge.night {
    background: linear-gradient(180deg, #4382cd 0%, #0c2748 100%);
  }
  .timeBadge.morning {
    background: linear-gradient(
      180deg,
      #ffe03e 0%,
      #eea113 23.96%,
      #ff5f04 87.5%
    );
  }

  .badgeWrap {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    img {
      z-index: 1;
    }
  }

  .commentBox {
    width: fit-content;
    padding: 4px 8px;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    border-radius: 0 10px 10px 0;

    h5 {
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      color: #ffffff;
    }
    h5.time {
      white-space: nowrap;
      color: #262626;
    }
    img {
      width: 20px;
      height: 20px;
      margin-right: 2px;
    }
  }
  .commentBox.subtitle {
    background: linear-gradient(94.78deg, #46f7c7 5.9%, #64b5da 92.49%);
  }
  .commentBox.coupon {
    background: linear-gradient(94.78deg, #ffc525 5.9%, #ff4848 92.49%);
  }
  .commentBox.free {
    background: linear-gradient(94.42deg, #d185ff 7.28%, #899cff 87.52%);
    img {
      width: 18px;
      height: 18px;
      margin: 0 0 0 3px;
      vertical-align: bottom;
    }
  }
  .commentBox:nth-child(1) {
    border-top-left-radius: 10px;
  }

  .arrivalWrap {
    position: absolute;
    bottom: 50px;
    right: 8px;
    display: flex;
    align-items: center;

    .commentBox {
      background: #ffffff50;
      max-width: fit-content;
      border-radius: 50px !important;
      h5 {
        color: #262626;
      }
      img {
        width: 14px;
        height: 14px;
        margin-right: 2px;
      }
    }
  }

  .arrivalWrap.left {
    left: 0;
    bottom: 42px;

    .commentBox {
      background: #00000050;
      max-width: fit-content;
      border-radius: 0 10px 0 10px !important;
      h5 {
        color: #fff;
      }
      img {
        width: 14px;
        height: 14px;
        margin-right: 2px;
      }
    }
  }

  .footerContainer {
    position: sticky;
    bottom: 0;
    z-index: 50;
  }

  /* voucherContentWrap */
  .voucherContentWrap {
    padding: 30px 27px;
  }
`;
